@use "../../styles/breakpoint.module.scss" as *;

@mixin svg-style {
    width: 1em;
    height: 1em;
    fill: currentColor;
}

@mixin common-clickable-2024 {
    --height: 3.5em;

    align-items: center;
    display: inline-flex;
    padding-top: 0.2em;
    font: var(--font-button);
    letter-spacing: 0.1em;
    height: var(--height);
    justify-content: center;
    text-transform: uppercase;
    overflow: hidden;
    transition:
        background-color 0.3s ease-in-out,
        color 0.3s ease-in-out;

    &:disabled,
    &.disabled {
        opacity: 0.5;
        cursor: default;
    }

    & svg {
        @include svg-style;

        margin-top: -0.2em;
    }
}

@mixin common-clickable-2026 {
    --height: 3em;

    display: inline-flex;
    align-items: center;
    height: var(--height);
    font: var(--font-button-18);
    overflow: hidden;
    transition:
        background-color 0.3s ease-in-out,
        color 0.3s ease-in-out;

    & svg {
        @include svg-style;
    }
}

// things that we want on all clickables, including "unstyled" ones
.base {
    composes: outline from "../../styles/composable/utility.module.css";
}

@mixin padded-clickable-2024 {
    @include common-clickable-2024;

    & .clickableContent,
    & :global(.clickableContent) {
        padding-inline: 1.7em;
        text-align: center;
    }
}

@mixin padded-clickable-2026 {
    @include common-clickable-2026;

    & .clickableContent,
    & :global(.clickableContent) {
        padding-inline: var(--spacer-24);
        text-align: center;
    }
}

// I don't think these are composed or imported anywhere; if so, they'll be with the old design
// .clickable {
//     @include common-clickable-2024;
// }
// .paddedClickable {
//     @include padded-clickable-2024;
// }

@mixin filled-button-2024 {
    @include padded-clickable-2024;

    background-color: var(--red);
    color: var(--white);

    &:hover:not(:disabled, .disabled) {
        background-color: var(--off-white);
        color: var(--black);
    }
}

@mixin filled-button-2026 {
    @include padded-clickable-2026;

    background: var(--primary-button-background);
    backdrop-filter: blur(10px);
    border: 1px solid var(--primary-button-text);
    border-radius: var(--border-radius-full);
    color: var(--primary-button-text);

    &:hover:not(:disabled, .disabled) {
        background: var(--primary-button-text);
        color: var(--color-primary);
    }

    &:disabled,
    &.disabled {
        background-color: var(--primary-button-disabled-background);
        border-color: var(--primary-button-disabled-text);
        color: var(--primary-button-disabled-text);
    }
}

.primaryButton {
    [data-design-version="v2024"] & {
        @include filled-button-2024;
    }

    [data-design-version="v2026"] & {
        @include filled-button-2026;
    }
}

@mixin secondary-button-2024 {
    @include common-clickable-2024;

    --height: auto;

    color: var(--color-text-tertiary);

    & > div {
        position: relative;
    }

    &:hover:not(:disabled, .disabled) {
        color: var(--red);
    }
}

@mixin secondary-button-2026 {
    @include filled-button-2026;

    background: var(--secondary-button-background);
    backdrop-filter: blur(10px);
    border-color: var(--secondary-button-border);
    border-radius: var(--border-radius-full);
    color: var(--secondary-button-text);

    &:hover:not(:disabled, .disabled) {
        background: var(--secondary-button-hover-background);
        border-color: var(--secondary-button-hover-border);
        color: var(--secondary-button-hover-text);
    }

    &:disabled,
    &.disabled {
        background-color: var(--secondary-button-disabled-background);
        border-color: inherit;
        color: var(--secondary-button-disabled-text);
    }
}

.buttonSecondary {
    [data-design-version="v2024"] & {
        @include secondary-button-2024;
    }

    [data-design-version="v2026"] & {
        @include secondary-button-2026;
    }
}

.clickableContent,
:global(.clickableContent) {
    display: inline-flex;
    align-items: center;
    flex-direction: row;
    gap: 0.5em;
    flex-shrink: 0;

    & > div {
        display: inline-flex;
        align-items: center;
        flex-shrink: 0;
    }
}

// Pulled from thelab-ui to reset links in a richtext context
:global(:where(.linkReset)) {
    cursor: pointer;
    display: inline-block;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    text-decoration: none;
}

.playPauseButton {
    align-items: center;
    background-color: var(--black);
    border-radius: 50%;
    color: var(--white);
    font-size: var(--font-p-18);
    height: 120px;
    justify-content: center;
    position: absolute;
    text-transform: uppercase;
    width: 120px;
}
